// components/GradientLegend.jsx
import React from 'react';

const GradientLegend = ({ colors = [], minLabel = '', maxLabel = '', height = 'h-4', minValue, maxValue, unit = '', ticksCount = 5, formatTick }) => {
  const gradient = `linear-gradient(to right, ${colors.join(', ')})`;
  const ticks = typeof minValue === 'number' && typeof maxValue === 'number' && ticksCount > 1
    ? Array.from({ length: ticksCount }, (_, i) => {
        const v = minValue + (i * (maxValue - minValue)) / (ticksCount - 1);
        const label = formatTick ? formatTick(v) : `${Math.round(v)}${unit ? ` ${unit}` : ''}`;
        return { label };
      })
    : [];

  return (
    <div className=" z-10 px-3 py-2 bg-[#20293F] bg-opacity-80 rounded-md shadow-sm w-full">
      <div
        className={`${height} w-full rounded-md`}
        style={{ background: gradient }}
      />
      {ticks.length > 0 ? (
        <div className="flex justify-between items-start mt-1">
          {ticks.map((t, idx) => (
            <div key={`${t.label}-${idx}`} className="flex flex-col items-center">
              <span className="w-px h-3 bg-white/50"></span>
              <span className="text-[10px] leading-none text-white mt-1">{t.label}</span>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex justify-between text-xs text-white mt-1">
          <span>{minLabel}</span>
          <span>{maxLabel}</span>
        </div>
      )}
    </div>
  );
};

export default GradientLegend;
